import axios, {AxiosRequestConfig} from 'axios';

import {ApiSuccessResponse} from './types';

export function httpPatch<T>(url: string, data?: AxiosRequestConfig['data']) {
  return axios.patch<ApiSuccessResponse<T>>(url, data);
}
